export default __webpack_public_path__ + "images/making-questions.svg";